<template>
    <div class="flex justify-between md:inline-grid grid-cols-3 md:gap-4 flex-1">
        <div class="md:flex gap-8 items-center font-serif text-white hidden">
            <a href="https://www.marker-ai.com/the-platform" class="router-link">The Platform</a>
            <router-link to="/resources" class="router-link">Resources</router-link>
            <a href="https://www.marker-ai.com/about" class="router-link">About Us</a>
            <a href="https://www.marker-ai.com/pricing" class="router-link">Pricing</a>

        </div>

        <MobileNav />

        <div class="text-center flex items-center justify-center gap-3">
            <router-link to="/" class="inline-block mx-auto p-4">
                <img src="../../assets/logo-marker.svg" alt="logo" class="h-5 md:h-7">
            </router-link>
            <!-- Country Flags -->
            <div class="flex items-center gap-1.5">
                <router-link to="/" class="flag-link" :class="{ 'flag-active': isActiveRegion('/') }" title="United Kingdom">
                    <span class="text-lg">🇬🇧</span>
                </router-link>
                <router-link to="/uae" class="flag-link" :class="{ 'flag-active': isActiveRegion('/uae') }" title="UAE">
                    <span class="text-lg">🇦🇪</span>
                </router-link>
                <router-link to="/us" class="flag-link" :class="{ 'flag-active': isActiveRegion('/us') }" title="United States">
                    <span class="text-lg">🇺🇸</span>
                </router-link>
                <router-link to="/australia" class="flag-link" :class="{ 'flag-active': isActiveRegion('/australia') }" title="Australia">
                    <span class="text-lg">🇦🇺</span>
                </router-link>
                <router-link to="/canada" class="flag-link" :class="{ 'flag-active': isActiveRegion('/canada') }" title="Canada">
                    <span class="text-lg">🇨🇦</span>
                </router-link>
            </div>
        </div>
        <div class="flex justify-end items-center">
            <a href="https://www.marker-ai.com/contact-us" class="btn btn-primary btn-xs font-sans">Learn More</a>
        </div>

    </div>



  </template>

<script>
import MobileNav from './MobileNav.vue'

export default {
  components: {
    MobileNav,
  },
  methods: {
    isActiveRegion(path) {
      const currentPath = this.$route.path;
      if (path === '/') {
        return currentPath === '/' || currentPath.startsWith('/cdd-') || currentPath.startsWith('/bo-') || currentPath.startsWith('/smart-') || currentPath.startsWith('/resources') || currentPath.startsWith('/acsp-') || currentPath.startsWith('/marker-demo');
      }
      return currentPath.startsWith(path);
    },
  },
};
</script>

<style scoped>
.flag-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  opacity: 0.5;
  transition: opacity 0.2s, transform 0.2s;
}
.flag-link:hover {
  opacity: 1;
  transform: scale(1.15);
}
.flag-active {
  opacity: 1;
}
</style>